import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-shadow */
import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioButton = function RadioButton(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      name = _ref.name,
      disabled = _ref.disabled,
      value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      onChange = _ref.onChange,
      containerStyles = _ref.containerStyles,
      inputStyles = _ref.inputStyles,
      dataCy = _ref.dataCy;

  var onChangeHandler = function onChangeHandler(event) {
    var _event$target = event.target,
        checked = _event$target.checked,
        value = _event$target.value;

    if (onChange) {
      onChange({
        isChecked: checked,
        value: value
      });
    }
  };

  return /*#__PURE__*/_jsxs("label", {
    className: classNames("rounded-full relative col cursor-pointer border border-gray-200", {
      'bg-emerald-500': checked,
      'bg-neutral-100': !checked
    }),
    style: _objectSpread(_objectSpread({
      lineHeight: 1,
      width: size,
      height: size
    }, containerStyles), {}, {
      padding: size * 0.3
    }),
    "data-cy": "label_".concat(dataCy || id),
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames('w-full h-full rounded-full', {
        'opacity-1 bg-white': checked,
        'opacity-0': !checked
      })
    }), /*#__PURE__*/_jsx("input", {
      id: id,
      "data-cy": dataCy || id,
      disabled: disabled,
      className: "cursor-inherit m-0 c-green-3 absolute",
      style: _objectSpread({
        width: 1,
        height: 1,
        left: -9999
      }, inputStyles),
      width: size,
      height: size,
      name: name,
      value: value,
      onChange: onChangeHandler,
      checked: checked,
      type: "radio"
    })]
  });
};